import { LABELS, LEVELS } from '../constants';
import type { PostContent } from '../types';

// Replaces Fleet's hardcoded NEW chip, so it expires like every other announcement. A feature, not a launch:
// everyone who can see Fleet was invited to EA Connect and already knows it. Its release is for the EA Connect role.
export const fleet: PostContent = {
  id: '2026-10-ea-connect-fleet',
  level: LEVELS.feature,
  label: LABELS.new,
  area: 'EA Connect',
  title: 'Your expert advisors, hosted and always on',
  summary:
    'EA Connect runs your MT4 and MT5 expert advisors on always-on managed servers. Fleet shows each one live, with equity and journal.',
  cta: { label: 'Open Fleet', route: '/ea-connect/fleet' },
  menuItemId: 'my-bots'
};
